import * as types from '../mutation-types';
import { Module } from 'vuex';

interface State {
  releaseVersion: null | number;
}

const initialState: State = {
  releaseVersion: null,
};

const headersModule: Module<State, any> = {
  namespaced: true,
  state: initialState,
  getters: {
    releaseVersion: state => state.releaseVersion,
  },
  actions: {
    setReleaseVersion({ commit, state, dispatch }, version: number) {
      if (state.releaseVersion == null) {
        commit(types.SET_RELEASE_VERSION, version);
      } else if (state.releaseVersion < version) {
        dispatch('globals/setShowRefreshModal', true, { root: true });
      }
    },
  },
  mutations: {
    [types.SET_RELEASE_VERSION](state: State, version) {
      state.releaseVersion = version;
    },
  },
};

export default headersModule;
